<template>
  <div>
    <time-filter v-model="dateRange" @change="onDateChange" />
    <br />
    <team-filter v-model="filterForm.teams" @change="onTeamChange" />
    <ci-coverage :filter-form="filterForm" />
    <ci-execute :filter-form="filterForm" />
    <br />
    <qa-member-filter v-model="qaFilterForm" @change="onQaMemberChange" />
    <ci-case :filter-form="qaFilterForm" />
  </div>
</template>

<script>
import TimeFilter from '@/pages/data/ciexecute/components/TimeFilter.vue';
import TeamFilter from '@/pages/data/ciexecute/components/TeamFilter.vue';
import QaMemberFilter from './components/QaMemberFilter.vue';
import CiCoverage from '@/pages/data/ciexecute/components/CiCoverage.vue';
import CiExecute from '@/pages/data/ciexecute/components/CiExecute.vue';
import CiCase from './components/CiCase.vue';

export default {
  components: { TimeFilter, TeamFilter, QaMemberFilter, CiCoverage, CiExecute, CiCase },
  data() {
    return {
      dateRange: null, // 临时变量用于处理日期范围选择
      filterForm: {
        begin_date: null,
        end_date: null,
        teams: []
      },
      qaFilterForm: {
        begin_date: null,
        end_date: null,
        qaMembers: [],
        period: 'month' // 添加周期字段
      }
    };
  },
  methods: {
    onDateChange(dateRange) {
      const updateDate = (form) => {
        if (dateRange?.length === 2) {
          form.begin_date = dateRange[0].format('YYYY-MM-DD');
          form.end_date = dateRange[1].format('YYYY-MM-DD');
        } else {
          form.begin_date = null;
          form.end_date = null;
        }
      };

      updateDate(this.filterForm);
      updateDate(this.qaFilterForm);
    },
    onTeamChange(checkedTeams) {
      this.filterForm.teams = checkedTeams;
    },
    onQaMemberChange(value) {
      this.qaFilterForm = { ...value }; // 直接接收合并后的对象
    }

  }
};
</script>

<style>
.customer-col {
  margin-top: 16px;
}
</style>
